import React from 'react'
import { Button, Divider, Segment, Header, Grid } from 'semantic-ui-react'

import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";


import ftMyerBasketball from '../images/articlePictures/ftMyerBasketball.png'
import clydeNatGuard from '../images/articlePictures/clydeNatGuard.png'
import clyde1941 from '../images/articlePictures/clyde1941.png'
import clyde1945 from '../images/articlePictures/clyde1945.png'
import clyekim47 from '../images/articlePictures/clyekim47.png'
import gail58 from '../images/articlePictures/gail58.png'
import clydeKimScooter51 from '../images/articlePictures/clydeKimScooter55.png'
import ednaclyde00 from '../images/articlePictures/ednaclyde00.png'



const options = {
    thumbnails: {
        showThumbnails: false
    // buttons: {
    //   backgroundColor: "#1b5245",
    //   iconColor: "rgba(126, 172, 139, 0.8)",
    // },
    // caption: {
    //   captionColor: "#a6cfa5",
    //   captionFontFamily: "Raleway, sans-serif",
    //   captionFontWeight: "300",
    //   captionTextTransform: "uppercase",
    }
  };

const ClydeBio = () => (

<React.Fragment>
<Segment  style={{ padding: '0em 0em' }} vertical>
    <Grid celled='internally' columns='equal' stackable>
        <Grid.Row textAlign='center'>
            <Grid.Column  style={{ paddingBottom: '0em', paddingTop: '0em' }}>
                <br/>
                <Header as='h3' style={{ fontSize: '2em' }}>Clyde James Richardson <br/> (1911 - 2002) </Header>
                <br/>

            </Grid.Column>
        </Grid.Row>

        <Grid.Row textAlign='left'>
            <Grid.Column  style={{ paddingBottom: '1em', paddingTop: '.5em' }} >
                <p class="sidePadding" style={{ fontSize: '1.33em' }}>
                <br/>
                Clyde was born on Sanibel Island on June 27, 1911 to Lucy and Oliver Richardson.  The family lived in the Sanibel House, a hotel that Lucy created out of the Hughes Floating Hotel.  The Sanibel House stood on the beach next to Grandpa’s house and Uncle Will’s house.  Lucy ran the hotel while Oliver farmed and dabbled in real estate.  Lucy had three children from a previous marriage to John Daniels, Bertha, Haskell and JB.
                <br/>
                <br/>
                His brother Frank was born two years later.  They attended school in a one-room schoolhouse.  All grades were together.  Some of the grades had as little as two or three kids in them.  The schoolteacher’s name was Miss Lettie Nutt.  They would sit in different areas and grade-by-grade they would go up front and the teacher would instruct them on their lesson.
                <br/>
                <br/>
                When Clyde was eight or nine, he was driving the family car.  Lucy or Oliver would ask him to drive to Bailey’s store to pick up something.  There were very few vehicles on the Island at the time.  So he encountered no traffic.
                <br/>
                <br/>
                During non school days they spent a lot of time swimming.  The boys usually wore only shorts with no shirts or shoes.  If they decided to go swimming they would just jump in.  If no one were around, they would take off their shorts and swim in the nude.   They also used large whiskey bottles as boats.  On one occasion Clyde and Frank were playing cops and robbers and Clyde picked up a gun on the porch and shot the bottom of Frank’s shoe off.  He hadn’t realized it was loaded.
                <br/>
                <br/>
                Oliver only whipped Clyde once.  He was told to feed the mules and he forgot.  When Oliver came home, he tore into him with a severe whipping.  After that Clyde always did what he was told.
                <br/>
                <br/>
                In 1926 another hurricane hit Sanibel.  This storm pretty much wiped out farming on the island.  The Richardson’s moved to Ft. Myers.  Oliver made a deal with the owner of some farmland south of town. 
                <br/>
                <br/>
                Clyde and Ben (Frank) went to school and worked what odd jobs they could find.  They also helped with the food by hunting and fishing.
                <br/>
                <br/> 
                In December of 1929, Clyde went to Cuba for a visit with the Boy Scouts.  The Cuban Boy Scouts acted as their hosts and they all had a good time.
                <br/>
                <br/>
                In 1929 the Richardson’s lived at 1921 Lee Street in Fort Myers.
                <br/>
                <br/>
                Occasionally, Oliver and Lucy would drive the boys to Arcadia to see Oliver’s family or go to Tampa to see his brothers, Hack and JB.
                <br/>
                <br/>
                As the boys got older, they would stay out until two or three o’clock in the morning.  Lucy would wait until they came and then she went to bed.
                <br/>
                <br/>
                In High School, Clyde and Frank were on the Football, Basketball and Baseball team. 
                <br/>
                <br/>
                <SimpleReactLightbox>
                    <SRLWrapper>
                    <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={ftMyerBasketball} class="articlePhoto" alt="1932 Fort Myers High School Basketball Team. Clyde is on the far left and his brother Frank is on far right" />
                    </div>
                <br/>
                <br/>
                In 1930, Clyde joined the National Guard.  Guard members were encouraged to ride the horses.  He spent many hours riding with friends through the fields and woods around Fort Myers.
                <br/>
                <br/>
                Clyde graduated from Fort Myers High School in June of 1932.
                <br/>
                <br/>
                Clyde was promoted to Corporal in the National Guard on July 26, 1932.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clydeNatGuard} class="articlePhoto" alt="1938 - Clyde on the left" />
                </div>
                <br/>
                <br/>
                Clyde and his family moved to a small two bedroom on Heitman Street, close to downtown in 1932.
                <br/>
                <br/>
                During the Depression Clyde and Ben grabbed what jobs they could find.  He had a paper route for several years.  He worked at the A&amp;P and the Sunshine Market.  For a week Clyde worked for Thomas Edison’s laboratory pulling leaves off branches
                <br/>
                <br/>
                In 1934, Ben was working for the Sunshine Market as a delivery boy.  His car struck a parked car and the steering wheel caused fatal internal injuries.
                <br/>
                <br/>
                Clyde’s first car was a second hand Oakland.  He paid $15.00.  It was stripped down to four wheels, an engine and a seat.  At that time there were no driver’s license or car tags to contend with.  Clyde got a job at the city pool as pool cleaner and lifeguard.
                <br/>
                <br/>
                In July of 1938, Clyde moved to Gainesville to work for his brother-in-law, David Kite.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clyde1941} class="articlePhoto" alt="1941 - Clyde" />
                </div>
                At first he lived with his sister Bert and Dave.  After a short while he rented a room with a friend close by on what was to be N.W. 2nd Avenue.  He dated a girl named Dorothy Cooper.  She also worked for Dave.
                <br/>
                <br/>
                On Sunday, December 7, 1941, Clyde was walking his dog when he stopped at a service station located on University Avenue and Sixth Street.  The radio was on and Clyde heard the first reports of the Japanese attacking Pearl Harbor.  The next day, Clyde went down to join the Navy.  Even though he was thirty years old, he was told he needed his parent’s signature.  He went outside and signed his parent’s names, went back in and was promptly accepted.
                <br/>
                <br/>
                His first assignment was as a member of a gun crew on the SS Geminy.  The ship lost a screw in the middle of the Northern Atlantic and the Captain told him to shoot at anything he saw.  When a whale surfaced, he popped off a few rounds of twenty millimeter at it.  He missed the whale but caught a mouthful from his Captain.
                <br/>
                <br/>
                As a gun crewmember on the SS Oliver Ellsworth, they were assigned to a Murmansk Convoy PQ-18.  The Ellsworth was torpedoed all hands had to abandon ship.
                <br/>
                <br/>
                On December 6, 1942, at the YMCA in Brooklyn, Clyde met Edna Frank over a checkerboard.  He escorted her home and asked her out on a date.  They wrote while Clyde was away and he visited her whenever he could. 
                <br/>
                <br/>
                In August of 1943, Clyde was transferred to the USS Marshall.  One of the Marshall’s first assignments was to join the USS Iowa and help with the destroyer screen.  The Iowa was bringing back President Roosevelt from a summit with Churchill and Stalin.
                <br/>
                <br/>
                The Marshall then went to the Pacific, where she took part in the Battle of the Philippine Sea and the battle of Leyte Gulf.
                <br/>
                <br/>
                Just before Christmas in 1944, Clyde sent a telegram to Edna.  It said to pack her bags, because she was going to Florida.  He sent her the money for a train ticket.  She took the train alone to Florida and when she arrived in Jacksonville, Clyde, and his sister Bert and her husband David met her.  They drove to Gainesville and spent the night.  Then they drove to Tampa and finally Fort Myers where she met the rest of the family.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clyde1945} class="articlePhoto" alt="1945 - Bert Kite, Clyde, Edna, &amp; Lucy Richardson" />
                </div>
                On December 19, 1945, Clyde was discharged from the Navy in Jacksonville, Florida.  On January 26, 1946, he married Edna in Brooklyn.  Dad’s Nephew Buddy Kite came up from Washington where he was stationed to attend the wedding.
                <br/>
                <br/>
                 Together they moved to Gainesville, Florida.  For six months they lived in a furnished house on West Court Street and paid David Kite, his brother in law, $35.00 per month rent.  Then they moved two houses down to a two-bedroom house at the corner (650 West Court Street).  This was unfurnished and they paid $20.00 per month.
                <br/>
                <br/>
                During the war, Clyde had sent money to David Kite to deposit for him in the bank.  David talked him into using the five hundred dollars that had accumulated, to buy a truck.  David had a small trucking business and he contracted to deliver freight.  One of his biggest customers was Sears.  After a short period of time, David decided to retire.  Clyde hired a man by the name of Louis for $20.00 a week and together they continued to deliver freight for Sears and whatever job came their way. 
                <br/>
                <br/>
                In 1947, Clyde and Edna had their first son, Kim Frank.
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={clyekim47} class="articlePhoto" alt="1947 - Clyde &amp; Kim" />
                </div>
                In 1949, they had their second child Tara who died two days later.
                <br/>
                <br/>
                In 1950 they bought a 1939 Chevy Truck from David Kite.
                <br/>
                <br/>
                In 1951, a friend borrowed Clyde’s work truck and threw a rod.  The truck wasn’t worth fixing.  Clyde used the wood on the truck to build Kim a playhouse. 
                <br/>
                <br/>
                Clyde talked Sears into hiring him full time.  The store manager hired him for $50.00 per week.  Also that year they got rid of the truck and bought a gray 1949 Ford.
                <br/>
                <br/>
                On October 7, 1954 they had their third child, Gail Dorothy.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={gail58} class="articlePhoto" alt="1958 - Gail" />
                </div>
                <br/>
                <br/>
                In 1955, Clyde bought a Cushman Scooter.  He rode it to work into the mid sixties.
                <br/>
                <br/>
                On January 1, 1956, Clyde and Edna moved to 549 NE 12th Court.  They paid $10,600 on a 25-year mortgage.
                <br/>
                <br/>
                On March 16, 1958, they had their fourth child, Jay Clyde.
                <br/>
                <br/>
                On November 5, 1959, they had their fifth child, Karen Lucy.
                <br/>
                <br/>
                On July 11, 1960, Clyde’s Mother, Lucy died.  Clyde took his family to Fort Myers for the funeral.  Hack, Addy, Bertha, Dave, JB, Rita and their kids were there.   After the service, Clyde kissed his mother goodbye for the last time.
                <br/>
                <br/>
                Clyde retired from Sears in 1976.  He then worked for a couple of years at the Howard Johnson Motel on 13th Street.  He took care of the grounds.  After that, he worked at the First Methodist Church for a few years taking care of the grounds and doing maintenance work.
                <br/>
                <br/>
                In March of 1989, Clyde, Edna and Karen traveled to Houston for their grandson’s (Kevin) first birthday and to see their granddaughter, Megan, for the first time. 
                <br/>
                <br/>
                On September 17, 1994, Clyde and Edna moved to 2718 NW 48th Terrace.
                <br/>
                <br/>
                On June 19, 1995, Clyde and Edna went to New Orleans and the Mississippi Gulf Coast for a reunion with their children and their families.  The family rode the Cajun Queen down the Mississippi River and went to the Aquarium of the Americans.  The next day they all drove to Biloxi.  The whole family visited Beauvoir (The Jefferson Davis home).
                <br/>
                <br/>
                On January 27, 1996 a big party was held to celebrate Clyde and Edna’s 50th Wedding Anniversary.  Friends and family from as far away as New York, Pennsylvania and Fort Myers joined in the celebration.
                <br/>
                <br/>
                In September of 1996, Clyde, Edna and Karen drove to Houston for a visit
                <br/>
                <br/>
                On June 25, 1998, Clyde made his last visit to his birthplace, Sanibel Island.  He went with Edna, Kim, Gail, Karen, Tiffany, Carol, Scott and Kevin.  Clyde pointed out the area where the Sanibel House stood.  They also went to the Sanibel Museum where they had Uncle Will’s post office building.
                <br/>
                <br/>
                <div class="column">
                    {/* <SRLWrapper options={options}> */}
                    <img src={ednaclyde00} class="articlePhoto" alt="2000 - Edna &amp; Clyde" />
                </div>
                <br/>
                <br/>
                On July 6, 2000, Clyde and Edna moved to Ocala.
                <br/>
                <br/>
                On March 16, 2002, Clyde fell and broke his hip.
                <br/>
                <br/>
                On March 30, 2002, Clyde was transferred to Marion House.  His Parkinson’s and his broken hip had confined him to bed.
                <br/>
                <br/>
                On June 15th Clyde was released from Marion House and he and Edna moved in with Gail and Donnie.
                <br/>
                <br/>
                On August 2, 2002, Jay and his family arrived in Ocala for a visit.  On Monday, August 5, Jay took his family and his Mother, Edna to MGM at Disney World.  That morning Clyde asked Gail where everyone was.  She told him and he said, that was good.  Then he told her to call Donnie and tell him he was team leader.  She said she would and when she didn’t go directly to the phone, he said to do it now.  She went to call Donnie and then did some other chores.  Soon the lady from Hospice arrived and Gail told her that Dad was asleep.  She went in and took one look and told Gail that Dad was dead.
                <br/>
                <br/>
                The funeral was held on Friday, August 9, 2002.  His wife Edna, and his children Kim, Gail, Jay and Karen, attended the funeral.  Also seven of his grandchildren were there.
                    </SRLWrapper>
                </SimpleReactLightbox>
                </p>
            </Grid.Column>
        </Grid.Row>
        </Grid>
    </Segment>
</React.Fragment>
)

export default ClydeBio